import {PropsWithChildren, ReactElement} from "react";
import classNames from "classnames";
import {FiCheck} from "react-icons/fi";
import "./FormControls.scss";

/**
 * Checkbox — themed replacement for the legacy checkbox. Same API
 * (`checked` / `onToggle` / `disabled` / `brandColor`). Anchor dark styling,
 * red check by default; `brandColor` overrides the accent for brand surfaces.
 */
interface Props {
    checked: boolean;
    onToggle: () => void;
    disabled?: boolean;
    className?: string;
    brandColor?: string;
}

function Checkbox(props: PropsWithChildren<Props>): ReactElement {
    function onClick(): void {
        if (!props.disabled) props.onToggle();
    }

    return (
        <label
            className={classNames("dp-checkbox", props.className, {
                "is-checked": props.checked,
                "is-disabled": props.disabled,
                "has-brand": Boolean(props.brandColor),
            })}
            style={props.brandColor ? {"--dp-checkbox-accent": props.brandColor} as React.CSSProperties : undefined}
        >
            <input type="checkbox" checked={props.checked} disabled={props.disabled} onChange={onClick}/>
            <span className="dp-checkbox__box">{props.checked && <FiCheck/>}</span>
            {props.children && <span className="dp-checkbox__label">{props.children}</span>}
        </label>
    );
}

export default Checkbox;
